// config.js
const config = {
    // apiUrl: 'http://localhost:3001',
    // apiUrl: 'http://10.237.175.69:3001',
    apiUrl: 'https://shanrakkargo.asia:3001',
    
    nameCargo: 'SHANRAK KARGO'

  };
  
  
export default config;
